import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import { addCertificate } from 'store/api/applications/application/certificates/certificatesActions';
import { AddCertificatePayload, AddCertificateResponse, ApplicationType } from 'store/api/types';

import { AddCertificate } from './AddCertificate';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onAddCertificate: (accountId: string, applicationId: string, payload: AddCertificatePayload) =>
    dispatch<Promise<AddCertificateResponse>>(addCertificate(accountId, applicationId, ApplicationType.PSD2, payload)),
});

export const AddCertificateContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(AddCertificate);
